import { render } from "./noRobot.vue?vue&type=template&id=1aa5af94&scoped=true"
import script from "./noRobot.vue?vue&type=script&lang=js"
export * from "./noRobot.vue?vue&type=script&lang=js"

import "./noRobot.vue?vue&type=style&index=0&id=1aa5af94&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa5af94"]])

export default __exports__